'use client';

import React from 'react';
import Typography from '@ui/Typography';
import Link from '@ui/Link';

function HomeFooter() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 py-8">
      <Typography
        variant="body1"
        component="a"
        href="https://help.neki.io"
        target="__blank"
        color="textSecondary"
        className="underline">
        Help
      </Typography>
      <Typography
        variant="body1"
        component="a"
        href="https://www.neki.io/terms-and-conditions"
        target="__blank"
        color="textSecondary"
        className="underline">
        Terms of Service
      </Typography>
      <Typography
        variant="body1"
        component="a"
        href="https://www.neki.io/privacy-policy"
        target="__blank"
        color="textSecondary"
        className="underline">
        Privacy Policy
      </Typography>
      <Typography
        variant="body1"
        component="a"
        href="https://www.neki.io/faqs"
        target="__blank"
        color="textSecondary"
        className="underline">
        FAQs
      </Typography>

      <Typography variant="body1" color="textSecondary" className="italic">
        Powered by
      </Typography>

      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="https://s3.amazonaws.com/my.neki.io.prod/assets/images/Neki-Logo.svg"
        className="h-auto w-24 bg-body-background"
        alt="neki logo"
      />
      <Typography variant="body1" color="textSecondary" className="text-center">
        &copy; {new Date().getFullYear()} by Neki Technologies Inc. All rights
        reserved.
      </Typography>
    </div>
  );
}

export default React.memo(HomeFooter);
